import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import useNavItems from '../../hooks/useNavItems'
import LayoutContext from '../../contexts/LayoutContext'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import RoutingEnum from '../../routes/appRoutes'
import {
  IconButtonLaptop,
  NavbarItemDesktop,
  StyledButtonDesktop,
  StyledNavbarList,
  StyledNavbarDesktopContainer,
  StyledNavbarGroup,
  StyledNavbarGroupRight,
  StyledNavbarMobileContainer,
  StyledSeparator,
} from './Navbar.styled'
import pxToRem from '../../utils/pxToRem'
import { IconTypeEnum } from '../../theme/icons'

import SearchIcon from '../../images/icons/search.svg'
import ContactIcon from '../../images/icons/contact.svg'
import NavBarMobile from './NavBarMobile'
import Logo from '../Logo/Logo'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'

const NAVBAR_NAME_KEY = 'search'

// TODO: Handle navigation state for styling

const Navbar = ({ companyNavigation, profilNavigation, light, scroll }) => {
  const isMobile = useMediaQuery(deviceMax.mobileL)

  const layoutState = useContext(LayoutContext)

  const [companyNavigationNav] = useNavItems(companyNavigation, scroll)
  const [profilNavigationNav] = useNavItems(profilNavigation, scroll)

  const searchIcon = <SearchIcon />

  return (
    <nav aria-label="navigation" id="menu">
      <StyledNavbarList $navOpacity={layoutState.navOpacity} role="navigation">
        <Logo light={light} isMobile={isMobile} />
        {!light && (
          <StyledNavbarMobileContainer>
            <NavBarMobile />
          </StyledNavbarMobileContainer>
        )}
        {!light && (
          <StyledNavbarDesktopContainer>
            <StyledNavbarGroup>{companyNavigationNav}</StyledNavbarGroup>
            <StyledSeparator />
            <StyledNavbarGroup>{profilNavigationNav}</StyledNavbarGroup>
            <StyledSeparator />
            <StyledNavbarGroupRight>
              <IconButtonLaptop
                ariaLabel={'search'}
                to={RoutingEnum.search}
                height={pxToRem(24)}
                width={pxToRem(24)}
                type={IconTypeEnum.search}
              >
                <SearchIcon />
              </IconButtonLaptop>

              <NavbarItemDesktop
                ariaLabel={'search'}
                key={NAVBAR_NAME_KEY}
                name={'Search'}
                slug={RoutingEnum.search}
                icon={searchIcon}
                scroll={scroll}
              />

              <IconButtonLaptop
                ariaLabel={'contact'}
                to={RoutingEnum.contact}
                height={pxToRem(24)}
                width={pxToRem(24)}
                type={IconTypeEnum.contact}
              >
                <ContactIcon />
              </IconButtonLaptop>

              <StyledButtonDesktop
                variant={ButtonVariantEnum.secondary}
                label={'Contact'}
                to={RoutingEnum.contact}
                scroll={scroll}
              />
            </StyledNavbarGroupRight>
          </StyledNavbarDesktopContainer>
        )}
      </StyledNavbarList>
    </nav>
  )
}

Navbar.propTypes = {
  companyNavigation: PropTypes.array.isRequired,
  profilNavigation: PropTypes.array.isRequired,
}

export default Navbar
